import React, { useState, useEffect } from "react";
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import {  Link } from 'react-router-dom';
import { SYSTMENACCESS } from 'helpers/viewContent';
import {getDetail_} from 'store/services/commonService';
import { DATE_FORMAT_TIME } from "helpers/common";

//imported
import * as Path from 'routes/paths';
import * as actions from 'store/actions/index.js';

const Detail = ({dispatch, match}) => {
    let editkey = match.params.id;
    const [editData, setEditData] = useState({});
    const [permissions, setPermissions] = useState([]);
    async function getData() {
        try{
            let query = {
                url : "system_access/view",
                id : editkey
            }
           dispatch(actions.persist_store({ loader:true}));
           let res = await dispatch(getDetail_(query))
           setEditData(res?.body?.data)
           setPermissions(res?.body?.data?.user_permissions)
           dispatch(actions.persist_store({ loader:false}));
        }catch(err) {
           dispatch(actions.persist_store({ loader:false}));
           console.log(err);
       }
    }
    
    useEffect(() => {
        if(editkey){
            getData()
        }
    }, []);
    return(
        <>
            <Helmet title={SYSTMENACCESS.CURRENT_MODULE} />
            <div className="page-header">
            <h3 className="page-title">
                <span className="page-title-icon bg-gradient-primary text-white me-2">
                <i className="mdi mdi-account-multiple menu-icon"></i>
                </span>  {SYSTMENACCESS.CURRENT_VIEW}
            </h3>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><Link to={Path.system_access}>System Access</Link></li>
                  <li className="breadcrumb-item active" aria-current="page">Detail</li>
                </ol>
              </nav>
            </div>
            
            <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <h4><b> Personal Info </b></h4>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-sm-6 col-form-label">Full Name</label>
                                        <div className="col-sm-6 col-form-label">
                                           {editData?.name ? editData?.name : 'N/A'}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group row">
                                    <label className="col-sm-6 col-form-label">Email</label>
                                        <div className="col-sm-6 col-form-label">
                                           {editData?.email ? editData?.email : 'N/A'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-sm-6 col-form-label">Status</label>
                                        <div className="col-sm-6 col-form-label">
                                            <p className={`badge badge-gradient-${editData?.status == 1 ? 'success' : 'danger'}`}>{editData?.status == 1 ? 'Active' : 'Inactive'}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-sm-6 col-form-label">Created At</label>
                                        <div className="col-sm-6 col-form-label">
                                            {editData?.created_at ? DATE_FORMAT_TIME(editData?.created_at) : 'N/A'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h4><b> Permissions </b></h4>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group row">
                                        
                                        {permissions?.length > 0 && permissions.map((list, i) => {
                                            let moduleName = JSON.parse(list.module_name)
                                        return(
                                            <div className="col-lg-3 col-form-label" key={i}>
                                                {moduleName?.label ? moduleName?.label : 'N/A'}
                                            </div>
                                        )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

const mapStateToPros = (state) => {
    return{
    }
  };
  function mapDispatchToProps(dispatch) {
    return { dispatch };
  }
  
  export default connect(
  mapStateToPros,
  mapDispatchToProps
  )(Detail);